import React from "react";
import { Typography } from "antd";
import SupportPageLayout from "./SupportPageLayout";
import "./supportPageLayout.css";

const { Paragraph } = Typography;

const CookiesPolicy = () => {
  return (
    <SupportPageLayout title="Cookie Policy">
      <Paragraph className="supportText">This Cookie Policy explains how we use cookies and similar technologies...</Paragraph>
      <Paragraph className="supportText"><strong>1. What are Cookies?</strong> Small text files stored on your device.</Paragraph>
      <Paragraph className="supportText"><strong>2. How We Use Cookies:</strong> Preferences, analytics, performance.</Paragraph>
      <Paragraph className="supportText"><strong>3. Types:</strong> Essential, analytics, functional.</Paragraph>
      <Paragraph className="supportText"><strong>4. Managing Cookies:</strong> Adjust in your browser settings.</Paragraph>
    </SupportPageLayout>
  );
};

export default CookiesPolicy;
